module.exports = __webpack_public_path__ + "081d09fc68112b75176c60711bde21b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-660.jpg
// module id = 286
// module chunks = 0